import React, { useState } from "react";
import ImportContactsModal, {
  ImportedContactFileInfoType,
  ImportedRecords,
} from "../Broadcast/ImportContactsModal";
import ImportedContactFilesList from "../Library/ImportedContactFilesList";
import { Form, Tab, Tabs } from "react-bootstrap";

export default function BroadcastImportContacts({
  importedFile,
  setFile,
  headers,
  filters,
}: {
  importedFile: ImportedContactFileInfoType | undefined;
  setFile: (f: ImportedContactFileInfoType | undefined) => void;
  headers?: string[];
  filters?: {
    status?: string;
    search?: string;
  };
}) {
  const [forceRefresh, setForceRefresh] = useState(new Date().toLocaleString());

  const actionButton = (f: ImportedContactFileInfoType) => (
    <Form.Check // prettier-ignore
      type="switch"
      id={"use-form-switch-" + f.file}
      label="Use this file"
      className="d-flex align-items-center bg-purple-gradient rounded-3 p-1"
      checked={importedFile?.file === f.file}
      onChange={() => {
        if (importedFile?.file === f.file) {
          setFile(undefined);
          return;
        }
        setFile(f);
      }}
    />
  );

  return (
    <div>
      <Tabs
        defaultActiveKey={importedFile ? "records" : "files"}
        id="imported-contacts-tabs"
        className="border-0"
        unmountOnExit
        mountOnEnter
      >
        {importedFile && (
          <Tab eventKey="records" title="Selected File Records">
            <div className="bg-white p-3 rounded-bottom-3 rounded-end-3 border-start ">
              <ImportedRecords importedFileId={importedFile.file} />
            </div>
          </Tab>
        )}
        <Tab eventKey="files" title="Files List">
          <div className="bg-white p-2 rounded-bottom-3 rounded-end-3 border-start ">
            <ImportedContactFilesList
              key={forceRefresh}
              actionButton={actionButton}
              selectedFileName={importedFile?.file}
              headers={headers}
              setFile={setFile}
              filters={filters}
              showViewRecordsButton
            />
          </div>
        </Tab>
      </Tabs>
    </div>
  );
}
